export default __webpack_public_path__ + "static/media/Group1.9a9ed2a4.png";